import styled from 'styled-components/macro';
import { Button } from '@la/ds-ui-components';
import { media } from 'lib/media-queries/mixins';

export const MakePaymentButton = styled(Button)`
  font: var(--ui-xtra-large-bold);
  padding: 12px;
`;

export const RollupButtonContainer = styled.div<{
  $containerPosition: number;
}>`
  ${({ $containerPosition }) => media.TabletPortraitDown`
    position: fixed;
    bottom: ${$containerPosition}px;
    left: 0;
    width: 100%;
    padding: 8px 12px;
    background-color: var(--white);
    transition: bottom 0.1s ease;
  `}
`;
